import {
    PaginationState,
    createColumnHelper,
    flexRender,
    getCoreRowModel,
    getSortedRowModel,
    SortingState,
    useReactTable,
} from "@tanstack/react-table";
import { LogsRowObj } from "..";
import Card from "components/card";
import DivLoader from "components/divloader/DivLoader";
import React, { useEffect, useState } from "react";
import Searchbox from "components/fields/Searchbox";
import moment from "moment";
import { BsArrowDown, BsArrowUp } from "react-icons/bs";
import { RiArrowUpDownFill } from "react-icons/ri";
import Pagination from "components/pagination";
import ShortTruncateCopy from "components/common/ShortTruncateCopy";
import FilterModal from "./FilterModal";

function AuditLogsTable(props:{
    users:any;
    tableData: any;
    fetchLogs: () => void;
    onValueChange: (value: string) => void;
    roleData?: any;
    isLoading: boolean;
    page: number;
    setPage: any;
    totalpage: number;
    totalItems: number;
    currentPage: number;
    pageSize: number;
    setPageSize: any;
    filterData: () => void;
    filter: any;
    setFilter: (e: any) => void;
    setLocalFilters?: (e: any) => void;
    setClearClick: () => void;
    localFilters?: any;
}) {

    const {users,filter,setFilter,setClearClick,setLocalFilters,localFilters,filterData,tableData,onValueChange,isLoading,roleData,page,setPage,totalpage,totalItems,currentPage,pageSize,setPageSize,fetchLogs} = props;
    let defaultData = tableData;
    const [searchVal, setSearchVal] = useState<any>("");
    
    const [{ pageIndex }, setPagination] = React.useState<PaginationState>({
        pageIndex: 0,
        pageSize,
    });

    const [expandedRow, setExpandedRow] = useState<string | null>(null);

    const pagination = React.useMemo(() => ({
        pageIndex,
        pageSize,
    }), [pageIndex, pageSize],);

    const handleExpand = (rowId : any) => {
        setExpandedRow(expandedRow === rowId ? null : rowId);
    };

    const columns = [
        columnHelper.accessor("created_at", {
            id: "created_at",
            header: () => (
                <p className="text-sm font-bold text-gray-900 dark:text-white">Created Date</p>
            ),
            cell: (info : any) => {
                const rawDate = info.getValue();
                const formattedDate = moment(rawDate).format("YYYY-MM-DD HH:mm:ss");
        
                return (
                    <p className="text-sm font-bold text-navy-700 dark:text-white flex items-center gap-1 cursor-pointer">{formattedDate}</p>
                );
            },   
        }),
        columnHelper.accessor("user_name", {
            id: "user_name",
            header: () => (
              <p className="text-sm font-bold text-gray-900 dark:text-white">User Name</p>
            ),
            cell: (info: any) => {
                return <>
                    <div className="flex items-center">
                        <p className="text-sm font-bold text-navy-700 dark:text-white">
                            {info?.getValue()}
                        </p>
                    </div>
                </>
            },
        }),
        columnHelper.accessor("module", {
            id: "module",
            header: () => (
              <p className="text-sm font-bold text-gray-900 dark:text-white">Module</p>
            ),
            cell: (info: any) => {
                return <>
                    <div className="flex items-center">
                        <p className="text-sm font-bold text-navy-700 dark:text-white">
                            {info?.getValue()}
                        </p>
                    </div>
                </>
            },
        }),
        columnHelper.accessor("description", {
            id: "description",
            header: () => (
              <p className="text-sm font-bold text-gray-900 dark:text-white">Action</p>
            ),
            cell: (info: any) => {
                return <>
                    <div className="flex items-center">
                        <p className="text-sm font-bold text-navy-700 dark:text-white">
                            {info?.getValue()}
                        </p>
                    </div>
                </>
            },
        }),
    ];
    

    const [sorting, setSorting] = React.useState<SortingState>([]);
    const [data, setData] = React.useState(() => [...defaultData]);

    useEffect(() => {    
        const processedData = tableData.map((item: any) => {
            return {
                ...item,
            };
        });
        setData(processedData);
    }, [tableData]);

    const table = useReactTable({
        data,
        columns: columns,
        state: {
        pagination,
        sorting,
        },
        onPaginationChange: setPagination,
        onSortingChange: setSorting,
        getCoreRowModel: getCoreRowModel(),
        getSortedRowModel: getSortedRowModel(),
        debugTable: true,
    });

    const handleValueChange = (e: any) => {
        onValueChange(e);
        setSearchVal(e);
    };

    return (
        <Card extra={"w-full h-full sm:overflow-auto px-6"}>
            <header className="relative flex items-center justify-between pt-5 flex-wrap">
                <div className="block w-full justify-between gap-5 md:flex lg:flex">
                    <div className="flex items-center gap-5">
                        <div className="text-xl font-bold text-navy-700 dark:text-white">
                        User Audit Logs
                        </div>
                    </div>
                    <div className="flex flex-wrap justify-around gap-2 md:pe-[0px] lg:pe-[0px]">
                        <FilterModal
                            users={users}
                            setPage={setPage}
                            filter={filter}
                            setFilter={setFilter}
                            filterData={filterData}
                            setLocalFilters={setLocalFilters}
                            localFilters={localFilters}
                            setClearClick={setClearClick}
                        />
                        <Searchbox onSearch={handleValueChange} />
                    </div>
                </div>
            </header>
            <div className="mt-4  overflow-x-auto scrollbar scrollbar-track-gray-100 scrollbar-thumb-gray-300 scrollbar-track-rounded-full scrollbar-thumb-rounded-xl scrollbar-h-1.5 relative overflow-x-auto shadow-md sm:rounded-lg">
                {props.isLoading ? (
                    <DivLoader className="m-5 h-6 w-6 border-indigo-500" />
                ) : (
                    <table className="w-full w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400 ">
                        <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400 ">
                            {table.getHeaderGroups().map((headerGroup) => (
                                <tr key={headerGroup.id} className="">
                                    {headerGroup.headers.map((header) => {
                                        return (
                                            <th
                                                key={header.id}
                                                colSpan={header.colSpan}
                                                onClick={header.column.getCanSort() ? header.column.getToggleSortingHandler() : undefined}
                                                className={`border-b-[1px] border-gray-200 pb-2 pr-4 pt-4 text-start p-2 ${header.column.getCanSort() ? 'cursor-pointer' : ''}`}
                                            >
                                                <div className="flex items-center text-xs text-gray-200">
                                                
                                                {flexRender(header.column.columnDef.header, header.getContext())}
                                        
                                                {header.column.getCanSort() && ( // Only show if sorting is enabled
                                                    <span className="ml-2">
                                                    {header.column.getIsSorted() === "asc" ? (
                                                        <BsArrowUp size={14} className="text-gray-900" />
                                                    ) : header.column.getIsSorted() === "desc" ? (
                                                        <BsArrowDown size={14} className="text-gray-900" />
                                                    ) : (
                                                        <RiArrowUpDownFill size={14} className="text-gray-900" />
                                                    )}
                                                    </span>
                                                )}
                                                </div>
                                            </th>
                                        )
                                    })}
                                </tr>
                            ))}
                        </thead>
                        <tbody >
                        {(table.getRowModel().rows?.length > 0) ? table.getRowModel().rows.map((row) => {
                            return (
                                <React.Fragment key={row.id}>
                                    <tr key={row.id} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600 ">
                                        {row.getVisibleCells().map((cell) => {
                                            return (
                                            <td
                                                key={cell.id}
                                                className="min-w-[150px] border-white/0 py-3  pr-4 p-2 font-bold text-gray-900"
                                            >
                                                {flexRender(
                                                cell.column.columnDef.cell,
                                                cell.getContext()
                                                )}
                                            </td>
                                            );
                                        })}
                                    </tr>
                                </React.Fragment>
                            )
                        }) :
                            <tr>
                                <td colSpan={4} >
                                <p className="text-center p-4" >No records found.</p>
                                </td>
            
                            </tr>
                        }
                        </tbody>
                    </table>
                )}
            </div>
            <Pagination
                setPage={setPage}
                page={page}
                totalpage={totalpage}
                currentPage={currentPage}
                pageSize={pageSize}
                setPageSize={setPageSize}
                arraySize={[50, 100, 200]}
            />
        </Card>
    )
}

export default AuditLogsTable;
const columnHelper = createColumnHelper<LogsRowObj>();